import Cookies from '~/components/utils/cookies';
/**
 * GROW-422, quick workaround for skipping onboarding
 * In a feature we could add a skip state to onboarding for certain posts
 */
export const SKIP_ONBOARDING_NAME = 'skip-onboarding';

const SKIP_ONBOARDING_PAGE_PATHS = ['/war-room/posts/shit-prospects-think-salespeople-do-everyday'];

export const skipOnboardingIfPageInException = (path: string) => {
  // NOTE: remove last /
  const pagePath = path.replace(/\/$/i, '');
  const isException = SKIP_ONBOARDING_PAGE_PATHS.includes(pagePath);
  if (isException) {
    // We check cookie in redirect middlware
    Cookies.set(SKIP_ONBOARDING_NAME, true);
  }
};
